import { createRootRoute, Outlet, useLocation } from "@tanstack/react-router";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/theme";
import { GlobalErrorComponent } from "@/components/GlobalErrorComponent";
import { NotFoundComponent } from "@/components/NotFoundComponent";
import { cn } from "@/lib/utils";

const THEME_SCRIPT = `(function(){try{var t=localStorage.getItem('theme')||'system';var d=t==='dark'||(t==='system'&&window.matchMedia('(prefers-color-scheme: dark)').matches);var r=document.documentElement;if(d){r.classList.add('dark');r.style.colorScheme='dark';}else{r.classList.remove('dark');r.style.colorScheme='light';}}catch(e){}})();`;

// eslint-disable-next-line react-refresh/only-export-components
function RootLayout() {
  const location = useLocation();
  const isExplorerRoute = location.pathname === "/" || location.pathname === "/explorer";

  return (
    <ThemeProvider>
      <div
        className={cn(
          "flex w-full flex-col bg-background text-foreground lg:zoom-90 xl:zoom-95 2xl:zoom-100",
          isExplorerRoute
            ? "h-screen overflow-hidden lg:h-[calc(100vh/0.9)] xl:h-[calc(100vh/0.95)] 2xl:h-screen"
            : "min-h-screen pt-20 sm:pt-24 lg:min-h-[calc(100vh/0.9)] xl:min-h-[calc(100vh/0.95)] 2xl:min-h-screen",
        )}>
        <Outlet />
      </div>
      <Sonner />
    </ThemeProvider>
  );
}

export const Route = createRootRoute({
  head: () => ({
    scripts: [
      {
        children: THEME_SCRIPT,
      },
    ],
  }),
  component: RootLayout,
  errorComponent: (props) => <GlobalErrorComponent error={props.error} />,
  notFoundComponent: () => <NotFoundComponent />,
});
